import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../../Common/Icon';

const ConstructionPlanSectionActions = ({ onDelete, onEdit }) => (
    <div className="constructionPlannerSection__actions">
        <button
            className="btn btn--backward-action btn--icon"
            onClick={onDelete}
        >
            <span className="btn__icon">
                <Icon name="delete" />
            </span>
        </button>
        <button
            className="btn btn--neutral-action btn--icon"
            onClick={onEdit}
        >
            <span className="btn__icon">
                <Icon name="edit" />
            </span>
        </button>
    </div>
);

ConstructionPlanSectionActions.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default ConstructionPlanSectionActions;
